var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-fade-overlay"},[_c('div',{staticClass:"c-fade-overlay__content"},[_vm._t("default")],2),_c('transition',{attrs:{"name":"fade"}},[(_vm.showOverlay)?_c('div',{staticClass:"c-fade-overlay__background"}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }